import ICONS from "../../../../assets/Icons";

const ConfirmBtnAccCreation = ({
  type,
  status,
  isIFSCValid,
  isBankError,
  isButtonDisabled,
  isGSTLoading,
  GSTStatus,
  lookupNext,
  nextButtonEnabled,
  isConfirmed,
  subtext,
  handleClick,
}) => {
  const isPan = type === "pan";
  const isRemitter = type === "remitter";

  const show =
    isPan || isRemitter ? status : status && isIFSCValid && !isBankError;

  const buttonStyles =
    isPan || isRemitter
      ? {
          color: "var(--text-primary)",
          opacity: isButtonDisabled
            ? "var(--light-opacity)"
            : "var(--base-opacity)",
          borderRadius: "var(--border-radius-sm)",
          cursor: !isButtonDisabled ? "pointer" : "default",
        }
      : {
          color: "var(--text-primary)",
          borderRadius: "var(--border-radius-sm)",
          opacity: isButtonDisabled
            ? "var(--light-opacity)"
            : "var(--base-opacity)",
          cursor: !isButtonDisabled ? "pointer" : "not-allowed",
        };

  const isConfirmIconPositive = isPan
    ? lookupNext && (GSTStatus == null || GSTStatus)
    : isRemitter
      ? isConfirmed
      : !nextButtonEnabled;

  return show ? (
    <div className="flex gap-gap-md justify-between items-center w-full rounded-border-radius-md bg-primary-card mb-margin-md py-padding-sm pr-padding-sm pl-padding-md">
      <div className="flex flex-col gap-gap-xs">
        <div className="w-full h-auto font-semibold text-font-md text-text-primary capitalize">
          Confirm to continue account creation
        </div>
        <div className="w-full h-auto font-normal text-xs text-text-secondary">
          {isRemitter
            ? subtext
            : isPan
              ? "Confirm and click ‘Next’ to add this account as an active account associated with the provided PAN."
              : "Confirm and click ‘Next’ to convert this account into a joint account and add it as an active account associated with the provided bank details."}
        </div>
      </div>
      <div
        className={`flex gap-gap-xs w-confirm-btn-width h-confirm-btn-height !p-padding-sm !normal-case
          ${
            isButtonDisabled
              ? "bg-primary-nav-act bg-no-repeat"
              : `relative z-z-index-base ${(lookupNext && (GSTStatus == null || GSTStatus)) || lookupNext || isConfirmed ? "bg-positive-bg global-hover-black" : "bg-primary-nav-act global-hover-white"}
          `
          }`}
        style={buttonStyles}
        disabled={
          isPan
            ? isGSTLoading
              ? true
              : !GSTStatus && GSTStatus != null
                ? true
                : isButtonDisabled
            : false
        }
        onClick={handleClick}
      >
        <div className="flex items-center">
          <img
            src={
              isConfirmIconPositive
                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
            }
            alt="btn-icon"
            className="h-icon-sm w-icon-sm flex-shrink-0"
          />
        </div>
        <div
          className={"flex items-center font-normal text-xs text-text-primary"}
        >
          Confirm
        </div>
      </div>
    </div>
  ) : null;
};

export default ConfirmBtnAccCreation;
